module.exports = __webpack_public_path__ + "assets/ic_tree30.125975fb.svg";